<template>
  <div ref="turnstileContainer" class="turnstile-container"></div>
</template>

<script>
export default {
  name: 'Turnstile',
  props: {
    siteKey: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'auto'
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      widgetId: null,
      retryCount: 0,
      maxRetries: 10,
      retryDelay: 200
    }
  },
  mounted() {
    this.waitForTurnstileAndRender()
  },
  beforeDestroy() {
    if (this.widgetId && window.turnstile) {
      try {
        window.turnstile.remove(this.widgetId)
      } catch (e) {
        console.warn('Failed to remove Turnstile widget:', e)
      }
    }
  },
  methods: {
    waitForTurnstileAndRender() {
      if (window.turnstile && window.turnstile.render) {
        this.renderTurnstile()
      } else if (this.retryCount < this.maxRetries) {
        this.retryCount++
        setTimeout(() => {
          this.waitForTurnstileAndRender()
        }, this.retryDelay)
      } else {
        console.error('Turnstile script failed to load after maximum retries')
        this.$emit('error', 'Turnstile script not available')
      }
    },
    renderTurnstile() {
      if (!window.turnstile || !window.turnstile.render) {
        console.error('Turnstile script not loaded')
        this.$emit('error', 'Turnstile not available')
        return
      }

      try {
        this.widgetId = window.turnstile.render(this.$refs.turnstileContainer, {
          sitekey: this.siteKey,
          theme: this.theme,
          size: this.size,
          callback: this.onSuccess,
          'error-callback': this.onError,
          'expired-callback': this.onExpired
        })
        this.$emit('rendered')
      } catch (error) {
        console.error('Failed to render Turnstile:', error)
        this.$emit('error', error)
      }
    },
    onSuccess(token) {
      this.$emit('verified', token)
    },
    onError(error) {
      console.error('Turnstile error:', error)
      this.$emit('error', error)
    },
    onExpired() {
      console.warn('Turnstile token expired')
      this.$emit('expired')
      this.$emit('verified', null)
    },
    reset() {
      if (this.widgetId && window.turnstile) {
        try {
          window.turnstile.reset(this.widgetId)
          this.$emit('verified', null)
        } catch (e) {
          console.warn('Failed to reset Turnstile widget:', e)
        }
      }
    }
  }
}
</script>

<style scoped>
.turnstile-container {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}
</style>